import {DomainObject, oneOf} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {t} from 'shared/core';
import {User} from 'main/stores/users';

class ExpensePolicyApprover extends DomainObject {
  id;
  approvalType;
  user;

  _relations = {
    user: User,
    approvalType: oneOf(['specific_user', 'manager'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      approvalType: observable,
      user: observable,
      value: computed,
      name: computed
    });

    this.merge(other);
  }

  get value() {
    return this.approvalType === 'manager' ? 'manager' : this.user.id;
  }

  get name() {
    return this.approvalType === 'manager'
      ? t('expenses.manage.policies.edit.Manager')
      : this.user.name;
  }
}

export default ExpensePolicyApprover;
